module.exports = __webpack_public_path__ + "static/media/travel-immunisation-badge.08037395.png";